<template lang="pug">
  v-container(fluid class="py-0")
    v-row(justify="center")
      v-col(cols="9" class="py-0 pl-10 pr-0")
        Title(:titleName="title" class="mb-4")
        Commerce(@set-commerce-type="setCommerceType" class="mb-2")
        Durations(@set-toggle-duration="setToggleDuration", class="mb-2")
        Types(@set-toggle-type="setToggleType", class="mb-2", :commerce="commerce", :duration="duration")
        div(v-if="this.userRole === 'Admin' || this.userRole === 'Company'", class="mb-6")
          h2(class="new-advert-subtitle") Комлекс
          v-row
            v-col(v-if="this.userRole === 'Admin'" cols="6")
              v-select(
                v-model="companyId",
                :items="companyList",
                item-text="name",
                item-value="companyId",
                dense,
                outlined,
                hide-details,
                label="Компания")
            v-col(cols="6")
              v-select(
                v-model="complexId",
                :items="complexCompanyList",
                item-text="name",
                item-value="complexId",
                dense,
                outlined,
                hide-details,
                label="Комплекс",
                no-data-text="У копмании пока нет комплексов")
        Address(
          @set-city-id="setCityId",
          @set-district-id="setDistrictId",
          @set-address="setAddress",
          class="mb-10")
        Price(
          :currencyList="currencyList",
          @set-currency="setCurrency",
          @set-price="setPrice",
          class="mb-2")
        div
          h2(class="new-advert-subtitle mb-2") Номер телефона:
          v-row()
            v-col(cols="6")
              v-text-field(
                v-model="phoneNumber",
                v-mask="phoneMask",
                outlined,
                dense,
                clearable,
                label="телефон",
                placeholder="(555) 11-22-33")
        DynamicItems(
          @set-fields="setFields",
          @set-extra-fields="setExtraFields",
          :advertType="advertType",
          :items="dynamicItems",
          class="mb-2")
        Images(@set-image-files="setImageFiles", class="mb-4")
        Description(@set-description="setDescription", class="mb-10")
        v-row(justify="center" class="mb-10")
          v-btn(large outlined width="200" class="mr-6" style="border-color:#c7c7c7", @click="onCancel") Отмена
          v-btn(large width="200" color="#07f" dark, @click="createAdvert", :loading="loading") Создать объявление
</template>

<script lang="js">
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import Images from '../../components/Adverts/AddNew/Images'
export default {
  name: 'AddNewAdvert',
  components: {
    Images,
    Price: () => import('@/components/Adverts/AddNew/Price'),
    Description: () => import('@/components/Adverts/AddNew/Description'),
    Commerce: () => import('@/components/Adverts/AddNew/Commerce'),
    Types: () => import('@/components/Adverts/AddNew/Types.vue'),
    Durations: () => import('@/components/Adverts/AddNew/Durations.vue'),
    Title: () => import('@/components/Adverts/AddNew/Title.vue'),
    Address: () => import('@/components/Adverts/AddNew/Address'),
    DynamicItems: () => import('@/components/Adverts/AddNew/DynamicItems.vue')
  },
  directives: {
    mask
  },
  created() {
    /**
     * dispatch 'GET_ADVERTS_ITEMS' - запрашивает с сервера данные по типу объявления 'advertType'.
     * @param {string} advertType - тип объявления
     */
    this.$store.dispatch('GET_ADVERTS_ITEMS', this.advertType)
    /**
     * dispatch 'GET_CURRENCY_LIST' - запрашивает данные о типах валюты с сервера.
     */
    this.$store.dispatch('GET_CURRENCY_LIST')
    this.$store.dispatch('GET_COMPANY_LIST')
  },
  data: () => ({
    title: 'Новое объявление',
    advertType: 'rentapartment',
    duration: 'daily',
    type: 'apartment',
    commerce: false,
    fields: {},
    extraFields: {},
    description: '',
    currency: 'som',
    price: null,
    cityId: null,
    districtId: null,
    address: '',
    files: [],
    loading: false,
    companyId: null,
    complexId: null,
    phoneMask: '+996(###)##-##-##',
    phoneNumber: ''
  }),
  watch: {
    duration(value) {
      value === 'sell'
        ? this.advertType = `sell${this.type}`
        : this.advertType = `rent${this.type}`

      this.$store.dispatch('GET_ADVERTS_ITEMS', this.advertType)
    },
    type(value) {
      this.duration === 'sell'
        ? this.advertType = `sell${value}`
        : this.advertType = `rent${value}`
      this.$store.dispatch('GET_ADVERTS_ITEMS', this.advertType)
    },
    userCompany(value) {
      if (value) this.companyId = value.companyId
    },
    companyId(value) {
      if (value) this.$store.dispatch('GET_COMPLEX_LIST', value)
    }
  },
  computed: {
    ...mapState({
      dynamicItems: state => state.advertItems,
      currencyList: state => state.currencyList,
      markerCoords: state => state.markerCoords,
      userRole: state => state.userInfo.role,
      userCompany: state => state.userCompany,
      companyList: state => state.company.companyList,
      complexCompanyList: state => state.complex.complexCompanyList,
      coords: state => state.coordinates
    })
  },
  methods: {
    onCancel() {
      this.$router.push({ path: '/' })
    },
    setToggleDuration(value) {
      this.duration = value
    },
    setToggleType(value) {
      this.type = value
    },
    setCommerceType(value) {
      this.commerce = value
    },
    setFields(value) {
      this.fields = value
    },
    setExtraFields(value) {
      this.extraFields = value
    },
    setDescription(value) {
      this.description = value
    },
    setCurrency(value) {
      this.currency = value
    },
    setPrice(value) {
      this.price = value
    },
    setCityId(value) {
      this.cityId = value
    },
    setDistrictId(value) {
      this.districtId = value
    },
    setAddress(value) {
      this.address = value
    },
    setImageFiles(files) {
      this.files = files
    },
    makeTrueParams() {
      let result = {}
      if (Object.keys(this.extraFields).length) {
        this.extraFields.map(filter => {
          result[filter] = true
        })
      }
      return result
    },
    validateParams() {
      let result = {}
      const fields = { ...this.fields }
      if (Object.keys(fields).length) {
        for (let item in fields) {
          if (fields[item] === undefined || fields[item] === null) {
            continue
          }
          result[item] = this.fields[item]
        }
      }
      return result
    },
    createFormData(id) {
      const media = new FormData()
      media.append('id', id)
      this.files.map(file => {
        media.append('images', file.file)
      })
      return media
    },
    async uploadImages(advertId) {
      const formData = await this.createFormData(advertId)
      const response = await this.$store.dispatch('UPLOAD_IMAGES', formData)
      this.loading = false
      if (response.error) console.log('error: ', response.error.message)
      return response
    },
    async createAdvert() {
      this.loading = true
      let advertId = null
      const payload = {
        ...this.validateParams(),
        ...this.makeTrueParams(),
        commerce: this.commerce,
        phone: this.phoneNumber.replace(/[^0-9]/g, ''),
        price: this.price,
        currency: this.currency,
        address: this.address,
        cityId: this.cityId,
        districtId: this.districtId,
        description: this.description,
        point: {
          latitude: this.markerCoords.latitude,
          longitude: this.markerCoords.longitude
        }
      }

      if (this.companyId) payload.companyId = this.companyId
      if (this.complexId) payload.complexId = this.complexId

      const response = await this.$store.dispatch('CREATE_ADVERT', {
        advertType: this.advertType,
        payload
      })
      if (response.error) {
        this.loading = false
        return
      }
      advertId = response.advertId

      const result = await this.uploadImages(advertId)
      if (result.error) {
        this.loading = false
        return
      }

      const updateResponse = await this.$store.dispatch('EDIT_ADVERT', {
        advertType: this.advertType,
        id: advertId,
        payload: { ...payload, images: result.images, isPublished: true }
      })
      this.loading = false
      if (updateResponse) await this.$router.push({ path: '/' })
    }
  }
}
</script>
